<template>
    <div v-if="messageErrorKey && showMessage && field.$anyDirty && field.$anyError" :class="className">
        <slot :name="messageErrorKey"></slot>
    </div>
</template>

<script>
    export default {
        name: 'ErrorMessagesBlock',
        props: {
            field: {
                required: true,
            },
            className: {
                required: false,
                default: 'error-messages ng-active',
            },
        },
        computed: {
            listErrorKeys() {
                return Object.keys(this.field.$params);
            },
            messageErrorKey() {
                let result = null;
                const { field, listErrorKeys } = this;
                for (let i = 0; i < listErrorKeys.length; i++) {
                    const error = field[listErrorKeys[i]];
                    if (error === false) {
                        result = listErrorKeys[i];
                        break;
                    }
                }
                return result;
            },
            showMessage() {
                // check slot empty or not
                return this.$slots[this.messageErrorKey]?.[0];
            },
        },
    };
</script>
